import { render, staticRenderFns } from "./ed-class-builder-placeholder-calendar.component.vue?vue&type=template&id=62b7d3c4&scoped=true&"
import script from "./ed-class-builder-placeholder-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-placeholder-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-placeholder-calendar.component.scss?vue&type=style&index=0&id=62b7d3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b7d3c4",
  null
  
)

export default component.exports